import type { CEFRLevel } from '@homeapp/shared';
import { useTranslation } from 'react-i18next';

interface Props {
  currentLevel: CEFRLevel;
  xpProgress: number;
  xpNeeded: number;
  nextLevel: CEFRLevel;
  totalXp: number;
}

export default function ProgressBar({ currentLevel, xpProgress, xpNeeded, nextLevel, totalXp }: Props) {
  const { t } = useTranslation();
  const percentage = Math.min((xpProgress / xpNeeded) * 100, 100);

  return (
    <div className="bg-white rounded-xl p-4 shadow-sm">
      <div className="flex items-center justify-between mb-2">
        <span className="text-sm font-bold text-indigo-600">{currentLevel}</span>
        <span className="text-xs text-gray-400">{xpProgress} / {xpNeeded} XP</span>
        <span className="text-sm font-bold text-gray-400">{nextLevel}</span>
      </div>
      <div className="h-3 bg-gray-200 rounded-full overflow-hidden">
        <div
          className="h-full bg-gradient-to-r from-indigo-500 to-purple-500 rounded-full transition-all duration-500"
          style={{ width: `${percentage}%` }}
        />
      </div>
      <div className="text-center mt-1">
        <span className="text-xs text-gray-400">{t('learning.totalXp', { xp: totalXp })}</span>
      </div>
    </div>
  );
}
